module.exports = __webpack_public_path__ + "static/baththermometer-05c1e8406abc30f9da6eecbcb613c8ec.jpeg";